module.exports = [
  { topic: 'About' },
  { topic: 'About Rooms' },
  { topic: 'Accessibility' },
  { topic: 'Activities' },
  { topic: 'Airport Transfer' },
  { topic: 'Amenity' },
  { topic: 'Baby Cot' },
  { topic: 'Baggage Locker' },
  { topic: 'Bike Rental' },
  { topic: 'Booking' },
  { topic: 'Breakfast' },
  { topic: 'Business Facilities' },
  { topic: 'Cancellations' },
  { topic: 'Car Rental' },
  { topic: 'Careers' },
  { topic: 'Check-in/out' },
  { topic: 'Common Area' },
  { topic: 'Concierge' },
  { topic: 'Contact Info' },
  { topic: 'Deals' },
  { topic: 'Elevator' },
  { topic: 'Emergencies' },
  { topic: 'EV Charging' },
  { topic: 'Event Enquiry' },
  { topic: 'Extra Beds' },
  { topic: 'Fallback' },
  { topic: 'Feedback' },
  { topic: 'Fitness Club' },
  { topic: 'Food Delivery' },
  { topic: 'Frontdesk' },
  { topic: 'Gaming' },
  { topic: 'Group Booking' },
  { topic: 'Highchair' },
  { topic: 'Housekeeping' },
  { topic: 'Human Chat' },
  { topic: 'Internet' },
  { topic: 'Kids Facilities' },
  { topic: 'Key Access' },
  { topic: 'Kitchen' },
  { topic: 'Languages' },
  { topic: 'Laundry' },
  { topic: 'Location' },
  { topic: 'Long Stay' },
  { topic: 'Meeting Room' },
  { topic: 'Membership' },
  { topic: 'Noisy Room' },
  { topic: 'Parking' },
  { topic: 'Payments' },
  { topic: 'Pets' },
  { topic: 'Restaurant' },
  { topic: 'Room Amenities' },
  { topic: 'Room Service' },
  { topic: 'Safety' },
  { topic: 'Security' },
  { topic: 'Smoking' },
  { topic: 'Swimming Pool' },
  { topic: 'Transport' },
  { topic: 'Vending Machine' },
  { topic: 'Views' },
  { topic: 'Xmas New Year Special' },
];
